module.exports = __webpack_public_path__ + "img/shop04.d081514b.jpg";